import { cores, itemsList } from "../Layout/constants";
import CryptoJS from "crypto-js";

function formatDateTimeLocal(date) {
  if (date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } else return "";
}

function codigoParaImagem(value) {
  const result = itemsList.find((item) => item.value === value);
  return result ? result.api : "ficha";
}
function codigoParaImagemLabel(value) {
  const result = itemsList.find((item) => item.value === value);
  return result ? result.label : "Ficha";
}

function codigoParaCor(codigo) {
  //console.log("codigo", codigo);
  const result = cores.find((item) => item.value === codigo);
  return result ? result.api : "azulEscuro";
}

function codigoParaLabel(codigo) {
  //console.log("codigo", codigo);
  const result = cores.find((item) => item.value === codigo);
  return result ? result.label : "Azul Escuro";
}

function codigoEvento() {
  const codEvento = CryptoJS.AES.decrypt(
    localStorage.getItem("eventoId"),
    process.env.REACT_APP_CYPHER_KEY
  ).toString(CryptoJS.enc.Utf8);
  return codEvento;
}

function convertAPIColor(argb) {
  const hex = argb.replace("$", "");
  const blue = hex.substring(2, 4);
  const green = hex.substring(4, 6);
  const red = hex.substring(6, 8);
  return `#${red}${green}${blue}`;
}

export {
  formatDateTimeLocal,
  codigoParaImagem,
  codigoParaCor,
  codigoEvento,
  convertAPIColor,
  codigoParaLabel,
  codigoParaImagemLabel,
};
